import { render, staticRenderFns } from "./PlaylistBadge.vue?vue&type=template&id=fa6a52dc"
import script from "./PlaylistBadge.vue?vue&type=script&lang=js"
export * from "./PlaylistBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa6a52dc')) {
      api.createRecord('fa6a52dc', component.options)
    } else {
      api.reload('fa6a52dc', component.options)
    }
    module.hot.accept("./PlaylistBadge.vue?vue&type=template&id=fa6a52dc", function () {
      api.rerender('fa6a52dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/PlaylistBadge.vue"
export default component.exports